module.exports = __webpack_public_path__ + "img/rune_05_te.4fc1bc2a.png";